import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useKBArticles } from '@/hooks/useKnowledgeBase';
import { useKBStore } from '@/stores/kbStore';
import KBArticleList from './KBArticleList';
import KBArticleView from './KBArticleView';

export default function KBSidebar() {
  const { t } = useTranslation();
  const { setOpen } = useKBStore();
  const { data, isLoading } = useKBArticles();
  const [selectedArticleId, setSelectedArticleId] = useState<number | null>(null);

  const handleArticleClick = (articleId: number) => {
    setSelectedArticleId(articleId);
  };

  const handleBackToList = () => {
    setSelectedArticleId(null);
  };

  return (
    <aside className="w-[380px] shrink-0 border-l border-go-border bg-base-200 flex flex-col animate-slide-in max-md:fixed max-md:inset-0 max-md:w-full max-md:z-[80]">
      {/* Header */}
      <div className="shrink-0 px-4 pt-4 pb-2 border-b border-go-border">
        <div className="flex items-center justify-between">
          <h2 className="text-sm font-semibold">{t('kb.title')}</h2>
          <button
            type="button"
            className="btn btn-ghost btn-sm btn-circle"
            onClick={() => setOpen(false)}
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-h-0 overflow-y-auto px-4 pb-4">
        {selectedArticleId !== null ? (
          <KBArticleView articleId={selectedArticleId} onBack={handleBackToList} />
        ) : (
          <KBArticleList
            articles={data?.articles || []}
            isLoading={isLoading}
            onArticleClick={handleArticleClick}
          />
        )}
      </div>
    </aside>
  );
}
